import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
export function ButtonList(props) {
    return _jsx(ButtonListRoot, { ...props });
}
export function ButtonListItem({ asLink = false, prependComponent, appendComponent, children, ...props }) {
    const tag = asLink ? 'a' : 'button';
    return (_jsxs(ButtonListItemRoot, { as: tag, ...props, children: [prependComponent, _jsx(ButtonListItemLabel, { children: children }), appendComponent] }));
}
const ButtonListItemLabel = styled.div `
    font-size: 1rem;
    letter-spacing: -0.04em;
    min-width: 0%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    flex: 1;
    font-weight: 500;

`;
const ButtonListItemRoot = styled.div `
    background-color: none;
    border: 0;
    background: none;
    min-height: 3.5rem;
    display: block;
    width: 100%;
    box-sizing: border-box;
    padding: 0;
    text-align: left;
    color: #ffffff;
    display: flex;
    gap: 0.75rem;
    padding: 0.75rem 1rem;
    align-items: center;
    font-size: 1rem;
    transition: 200ms background-color;

    button& {
        appearance: none;
    }

    a& {
        text-decoration: none;
    }

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
        transition-duration: 50ms;
    }
`;
const ButtonListRoot = styled.ul `
    background: rgba(202, 202, 202, 0.9);
    border: 1px solid rgba(222, 222, 222, 0.2);
    box-shadow: 0px 0.75rem 1.5rem rgba(0, 0, 0, 0.3),
        inset 0px 0px 0.125rem rgba(255, 255, 255, 0.8);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    box-sizing: border-box;
    border-radius: 1rem;
    min-height: 3.5rem;
    overflow: hidden;

    > li + li {
        border-top: 0.0625rem solid rgba(255, 255, 255, 0.3);
    }
`;
